import React from "react";
import {
  FILTER_ALL,
} from "../utils/constants";

/**
 * Chat UI state hook - manages all local UI state.
 */
export function useChatUIState() {
  const [search, setSearch] = React.useState("");
  const [filter, setFilter] = React.useState(FILTER_ALL);
  const [draft, setDraft] = React.useState("");
  const [pendingFiles, setPendingFiles] = React.useState([]);
  const [pendingFilePreviews, setPendingFilePreviews] = React.useState({});
  const [replyTo, setReplyTo] = React.useState(null);
  const [sending, setSending] = React.useState(false);
  const [loadingMore, setLoadingMore] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(() =>
    typeof window !== "undefined" ? window.matchMedia("(max-width: 768px)").matches : false
  );
  const [sidebarHiddenMobile, setSidebarHiddenMobile] = React.useState(false);
  const [infoOpen, setInfoOpen] = React.useState(() =>
    typeof window !== "undefined" ? !window.matchMedia("(max-width: 768px)").matches : true
  );
  const [showScrollBottomFab, setShowScrollBottomFab] = React.useState(false);
  const [highlightMessageKey, setHighlightMessageKey] = React.useState("");
  const [emojiPickerOpen, setEmojiPickerOpen] = React.useState(false);
  const [pickerMode, setPickerMode] = React.useState("emoji");
  const [reactionPickerMessage, setReactionPickerMessage] = React.useState(null);
  const [dragOver, setDragOver] = React.useState(false);
  const [confirmDeleteMessage, setConfirmDeleteMessage] = React.useState(null);
  const [selectedEmojiCategory, setSelectedEmojiCategory] = React.useState(0);
  const [selectedStickerCategory, setSelectedStickerCategory] = React.useState(0);
  const [editingMessage, setEditingMessage] = React.useState(null);
  const [mediaGallery, setMediaGallery] = React.useState(null); // { images, index }

  const fileInputRef = React.useRef(null);
  const textareaRef = React.useRef(null);
  const messagesRef = React.useRef(null);
  const loadingMoreRef = React.useRef(false);
  const deepLinkOpenRef = React.useRef(false);
  const deepLinkJumpRef = React.useRef(false);
  const readMarkRef = React.useRef("");
  const draftLimitNoticeAtRef = React.useRef(0);

  return {
    // State
    search, setSearch,
    filter, setFilter,
    draft, setDraft,
    pendingFiles, setPendingFiles,
    pendingFilePreviews, setPendingFilePreviews,
    replyTo, setReplyTo,
    sending, setSending,
    loadingMore, setLoadingMore,
    isMobile, setIsMobile,
    sidebarHiddenMobile, setSidebarHiddenMobile,
    infoOpen, setInfoOpen,
    showScrollBottomFab, setShowScrollBottomFab,
    highlightMessageKey, setHighlightMessageKey,
    emojiPickerOpen, setEmojiPickerOpen,
    pickerMode, setPickerMode,
    reactionPickerMessage, setReactionPickerMessage,
    dragOver, setDragOver,
    confirmDeleteMessage, setConfirmDeleteMessage,
    selectedEmojiCategory, setSelectedEmojiCategory,
    selectedStickerCategory, setSelectedStickerCategory,
    editingMessage, setEditingMessage,
    mediaGallery, setMediaGallery,

    // Refs
    fileInputRef,
    textareaRef,
    messagesRef,
    loadingMoreRef,
    deepLinkOpenRef,
    deepLinkJumpRef,
    readMarkRef,
    draftLimitNoticeAtRef,
  };
}
